import React from 'react';
import { IconProps } from './types';

const AgencyCircularIcon: React.FC<IconProps> = props => {
  const { width = '54', height = '54', fillColor = 'var(--blue-base)', className } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27" cy="27" r="27" fill="var(--blue-bg)" />
      <mask
        id="mask0_4001_69390"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="11"
        width="32"
        height="32"
      >
        <rect x="11" y="11" width="32" height="32" fill="var(--lightgray-base)" />
      </mask>
      <g mask="url(#mask0_4001_69390)">
        <path
          d="M19 33.6667C18.6222 33.6667 18.3053 33.5387 18.0493 33.2827C17.7942 33.0276 17.6666 32.7112 17.6666 32.3334V25.6334C17.6666 25.2556 17.7942 24.9445 18.0493 24.7001C18.3053 24.4556 18.6222 24.3334 19 24.3334C19.3777 24.3334 19.6946 24.461 19.9506 24.7161C20.2057 24.9721 20.3333 25.289 20.3333 25.6667V32.3667C20.3333 32.7445 20.2057 33.0556 19.9506 33.3001C19.6946 33.5445 19.3777 33.6667 19 33.6667ZM27 33.6667C26.6222 33.6667 26.3057 33.5387 26.0506 33.2827C25.7946 33.0276 25.6666 32.7112 25.6666 32.3334V25.6334C25.6666 25.2556 25.7946 24.9445 26.0506 24.7001C26.3057 24.4556 26.6222 24.3334 27 24.3334C27.3777 24.3334 27.6946 24.461 27.9506 24.7161C28.2057 24.9721 28.3333 25.289 28.3333 25.6667V32.3667C28.3333 32.7445 28.2057 33.0556 27.9506 33.3001C27.6946 33.5445 27.3777 33.6667 27 33.6667ZM14.9666 39.0001C14.5888 39.0001 14.2777 38.8721 14.0333 38.6161C13.7888 38.361 13.6666 38.0445 13.6666 37.6667C13.6666 37.289 13.7946 36.9725 14.0506 36.7174C14.3057 36.4614 14.6222 36.3334 15 36.3334H39.0333C39.4111 36.3334 39.7222 36.4614 39.9666 36.7174C40.2111 36.9725 40.3333 37.289 40.3333 37.6667C40.3333 38.0445 40.2053 38.361 39.9493 38.6161C39.6942 38.8721 39.3777 39.0001 39 39.0001H14.9666ZM35 33.6667C34.6222 33.6667 34.3057 33.5387 34.0506 33.2827C33.7946 33.0276 33.6666 32.7112 33.6666 32.3334V25.6334C33.6666 25.2556 33.7946 24.9445 34.0506 24.7001C34.3057 24.4556 34.6222 24.3334 35 24.3334C35.3777 24.3334 35.6942 24.461 35.9493 24.7161C36.2053 24.9721 36.3333 25.289 36.3333 25.6667V32.3667C36.3333 32.7445 36.2053 33.0556 35.9493 33.3001C35.6942 33.5445 35.3777 33.6667 35 33.6667ZM28.2 12.9334L39.4333 18.5334C39.7222 18.689 39.9444 18.9054 40.1 19.1827C40.2555 19.461 40.3333 19.7667 40.3333 20.1001C40.3333 20.5445 40.1724 20.9165 39.8506 21.2161C39.528 21.5165 39.1444 21.6667 38.7 21.6667H15.3333C14.8888 21.6667 14.5 21.5165 14.1666 21.2161C13.8333 20.9165 13.6666 20.5445 13.6666 20.1001C13.6666 19.789 13.7391 19.489 13.884 19.2001C14.028 18.9112 14.2555 18.7001 14.5666 18.5667L25.8 12.9334C26.1777 12.7556 26.5777 12.6667 27 12.6667C27.4222 12.6667 27.8222 12.7556 28.2 12.9334Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default AgencyCircularIcon;
